import { _axios } from "../../../Utils/Axios/axios";

export const getHomePageSlides_Service = async (userToken: string) => {
  return _axios.get("/sliders", {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
